import React from 'react'
import './separator.css'

const Separator = () => {
  return (
    <div className="byyourside_separator" />
  )
}

export default Separator
